import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import MoreHoriz from "@material-ui/icons/MoreHoriz";

import * as store from "../../store/flyer.store";
import { FlyerListTableOptionsMenuProps } from "./flyer-list-table-options-menu.props";
import { DeleteConfirmationModal } from "../../../../components/modals/delete-confirmation-modal/delete-confirmation-modal.component";

export const FlyerListTableOptionsMenu = (props: FlyerListTableOptionsMenuProps) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchor);

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const onConfirmDelete = () => {
    store.deleteFlyer(props.id);
  };

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const toggleConfirmModalOpen = () => {
    setConfirmModalOpen(!confirmModalOpen);
  };

  return (
    <>
      <Button onClick={openMenu}>
        <MoreHoriz />
      </Button>
      <Menu
        anchorEl={menuAnchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
        keepMounted
        MenuListProps={{ onMouseLeave: closeMenu }}
        onClose={closeMenu}
        open={menuOpen}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={toggleConfirmModalOpen}>Delete</MenuItem>
      </Menu>
      <DeleteConfirmationModal
        isOpen={confirmModalOpen}
        description={props.name}
        onConfirm={onConfirmDelete}
        onCancel={toggleConfirmModalOpen}
      />
    </>
  );
};
